import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import type { TabBarState } from '../types/store/tabBar.types'

export const useTabBarStore = create<TabBarState>()(
  devtools(
    (set) => ({
      hiddenReasons: new Set<string>(),
      isHidden: false,
      hide: (reason) =>
        set((state) => {
          if (state.hiddenReasons.has(reason)) return state
          const next = new Set(state.hiddenReasons)
          next.add(reason)
          return { hiddenReasons: next, isHidden: next.size > 0 }
        }),
      show: (reason) =>
        set((state) => {
          if (!state.hiddenReasons.has(reason)) return state
          const next = new Set(state.hiddenReasons)
          next.delete(reason)
          return { hiddenReasons: next, isHidden: next.size > 0 }
        }),
    }),
    { name: 'TabBarStore', enabled: import.meta.env.DEV },
  ),
)
